import { defineCommands, type CommandsOf, applyEntityDataChanges } from '../../commands/defineCommands';
import type { CanvasStoreContext } from '../../types';
import type { SpriteData } from '../../sprites/spriteTypes';

export const spriteCommands = defineCommands({
  'sprite.updateData': (ctx: CanvasStoreContext, event: {
    entityId: string; dataChanges: Partial<SpriteData>;
  }): CanvasStoreContext => applyEntityDataChanges(ctx, event.entityId, event.dataChanges),
});

export type SpriteCommand = CommandsOf<typeof spriteCommands>;
